import { useResource } from "../../../Hooks/UseResource";

export default function CountryResource() {
    const[resourceError, loading, getData, postData, uploadData] =useResource();

   const getCountryByShortName =(shortName)=>{
        return getData( {url:'/public/countryByShortName',  params:{"shortName":shortName}});       
   };

   const getCountryByMobileCountryCode =(mobileCountryCode)=>{
    return getData( {url:'/public/get-mobile-country-by-country-code',  params:{"mobileCountryCode":mobileCountryCode}});       
   };

   return {
    getCountryByShortName: getCountryByShortName,
    getCountryByMobileCountryCode: getCountryByMobileCountryCode,
  };

}